export const consultantChatArticle = {
  title: 'AI Business Consultant: Chat Workspace',
  slug: 'consultant-chat',
  content: `AI Business Consultant: Chat Workspace

The Chat tab is where you hold live conversations with the AI consultant.

1) Select a persona
- The chat introduces consultant personas (Strategy, Marketing, Finance).
- Use the consultant prompts to steer the conversation.

2) Ask questions and give tasks
- Type a message and press send.
- The consultant can return guidance and tool results.

3) Use business context
- Enable business context to let the AI reference your saved business data.

4) Voice and audio tools
- Enable text-to-speech in Settings to hear responses.
- Voice input is available when configured in Settings.

5) Open chat history
- Select previous conversations from the History tab to continue them.
`,
};
